import { useMutation, useQuery } from '@apollo/client/react';
import { toast } from 'sonner';
import { graphql } from '@/gql';
import { saveErrorMessage } from '@/shared/lib/graphql-errors';

export const CRAWLER_FLEET = graphql(`
  query CrawlerFleet {
    scraperOverview {
      fleet {
        isManaged
        busyTasks
        maxTasks
        desired
        running
        pending
        emptySince
        lastDesired
        lastReason
        lastScaledAt
        updatedAt
      }
    }
  }
`);

export const SET_CRAWLER_BUSY_TASKS = graphql(`
  mutation SetCrawlerBusyTasks($input: SetCrawlerBusyTasksInput!) {
    setCrawlerBusyTasks(input: $input) {
      isManaged
      busyTasks
      maxTasks
      desired
      running
      pending
      emptySince
      lastDesired
      lastReason
      lastScaledAt
      updatedAt
    }
  }
`);

export const useCrawlerFleet = () =>
  useQuery(CRAWLER_FLEET, { fetchPolicy: 'network-only', pollInterval: 30_000 });

export const useSetCrawlerBusyTasks = () =>
  useMutation(SET_CRAWLER_BUSY_TASKS, {
    refetchQueries: [CRAWLER_FLEET],
    onCompleted: (data) =>
      toast.success(
        data.setCrawlerBusyTasks.busyTasks === 0
          ? 'Crawler workers will stay stopped.'
          : `Crawler workers set to ${data.setCrawlerBusyTasks.busyTasks} while there is work.`,
      ),
    onError: (error) =>
      toast.error(saveErrorMessage(error, "Couldn't change the crawler workers.")),
  });
